<template>
  <div class="restaurant-orders-page">
    <div v-if="merchant">
      <div
        v-if="heroImage"
        class="restaurant-orders-hero"
        :style="{ backgroundImage: 'url(' + heroImage + ')' }"
      >
        <div class="restaurant-orders-hero-overlay">
          <div class="restaurant-orders-hero-inner">
            <div class="restaurant-orders-title">
              {{ merchant.title }}
            </div>
            <button
              type="button"
              class="restaurant-orders-menu-btn"
              @click="openMenus"
            >
              View Menus
            </button>
          </div>
        </div>
      </div>
      <div v-else class="restaurant-orders-hero restaurant-orders-hero-plain">
        <div class="restaurant-orders-hero-overlay">
          <div class="restaurant-orders-title">
            {{ merchant.title }}
          </div>
        </div>
      </div>

      <div class="restaurant-orders-content">
        <div v-if="tableFloors.length > 0">
          <div class="restaurant-orders-instruction">
            Please select your table
          </div>
          <div
            v-for="floor in tableFloors"
            :key="floor.id"
            class="restaurant-orders-floor"
          >
            <div class="restaurant-orders-floor-title">
              {{ floor.name }}
            </div>
            <div class="restaurant-orders-tables">
              <button
                v-for="table in floor.tables"
                :key="table.id"
                type="button"
                class="restaurant-orders-table-btn"
                @click="onTableSelected(table)"
              >
                {{ getTableLabel(table) }}
              </button>
            </div>
          </div>
        </div>
        <div v-else-if="!loading" class="restaurant-orders-empty">
          No tables available.
        </div>
      </div>

      <div
        v-if="showConfirm && selectedTable"
        class="restaurant-orders-confirm-overlay"
      >
        <div class="restaurant-orders-confirm-dialog">
          <div class="restaurant-orders-confirm-title">
            Please confirm your table
          </div>
          <div class="restaurant-orders-confirm-body">
            You have selected
            <span class="restaurant-orders-confirm-table">
              {{ getTableLabel(selectedTable) }}
            </span>.
          </div>
          <div class="restaurant-orders-confirm-actions">
            <button
              type="button"
              class="restaurant-orders-btn secondary"
              @click="cancelSelection"
            >
              Cancel
            </button>
            <button
              type="button"
              class="restaurant-orders-btn primary"
              @click="confirmSelection"
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../api/event-bus";
import { getMerchantPermalink, getTableList } from "../api/borium";

export default {
  name: "RestaurantOrders",
  data() {
    return {
      merchant: null,
      images: [],
      loading: true,
      tables: [],
      tableFloors: [],
      showConfirm: false,
      selectedTable: null,
    };
  },
  computed: {
    heroImage() {
      if (this.images.length > 0) {
        return this.images[0];
      }
      if (
        this.merchant &&
        this.merchant.imageUrl &&
        this.merchant.imageUrl.length > 0
      ) {
        return this.merchant.imageUrl.split(",")[0];
      }
      return null;
    },
  },
  mounted() {
    this.loadPage();
  },
  methods: {
    getTableLabel(table) {
      if (!table) return "";
      return table.name || table.title || ("Table " + table.id);
    },
    loadPage() {
      const self = this;
      if (this.$route.params.hasOwnProperty("permalink")) {
        const permalink = this.$route.params.permalink;
        getMerchantPermalink(permalink)
          .then(function (data) {
            if (data.success === true && data.item) {
              self.onMerchantLoaded(data.item);
            } else {
              self.loading = false;
            }
          })
          .catch(function () {
            self.loading = false;
          });
      } else {
        this.loading = false;
      }
    },
    onMerchantLoaded(merchant) {
      this.merchant = JSON.parse(JSON.stringify(merchant));
      this.images = [];

      if (
        merchant.webSetting &&
        merchant.webSetting.imageUrls &&
        merchant.webSetting.imageUrls.length > 0
      ) {
        this.images = merchant.webSetting.imageUrls.split(",");
      } else if (merchant.imageUrl && merchant.imageUrl.length > 0) {
        this.images = merchant.imageUrl.split(",");
      }

      EventBus.$emit("setTitle", this.merchant.title);
      this.fetchTables();
    },
    fetchTables() {
      const self = this;
      this.tables = [];
      this.tableFloors = [];

      let subscriptionId = null;
      if (
        this.merchant &&
        this.merchant.webSetting &&
        this.merchant.webSetting.subscription_id
      ) {
        subscriptionId = this.merchant.webSetting.subscription_id;
      } else if (this.merchant && this.merchant.merchantId) {
        subscriptionId = this.merchant.merchantId;
      }

      if (!subscriptionId) {
        this.loading = false;
        return;
      }

      const excludedTableTypes = [
        "Take Away",
        "Delivery",
        "Self Mahine",
        "Bar",
        "Counter",
        "Table Uber",
        "Table Deliveroo",
        "Table HungryPanda",
        "Table Justeat",
        "Table Cost",
      ];

      getTableList(subscriptionId)
        .then(function (data) {
          if (data.success === true && Array.isArray(data.list)) {
            for (let i = 0; i < data.list.length; i++) {
              const floorSource = data.list[i];
              const floor = {
                id: floorSource.id,
                name:
                  floorSource.name ||
                  floorSource.title ||
                  "Floor " + (i + 1),
                tables: [],
              };
              if (Array.isArray(floorSource.list)) {
                for (let j = 0; j < floorSource.list.length; j++) {
                  const t = floorSource.list[j];
                  const tt = (t.table_type || "").trim();
                  if (excludedTableTypes.indexOf(tt) >= 0) continue;
                  self.tables.push(t);
                  floor.tables.push(t);
                }
              }
              if (floor.tables.length > 0) {
                self.tableFloors.push(floor);
              }
            }
          }
          self.loading = false;
        })
        .catch(function () {
          self.loading = false;
        });
    },
    onTableSelected(table) {
      if (!table || !table.id) {
        return;
      }
      this.selectedTable = table;
      this.showConfirm = true;
    },
    cancelSelection() {
      this.showConfirm = false;
      this.selectedTable = null;
    },
    confirmSelection() {
      if (!this.selectedTable || !this.selectedTable.id) {
        this.cancelSelection();
        return;
      }
      const id = this.selectedTable.id;
      this.cancelSelection();
      this.$router.push("/restaurant?table=" + id);
    },
    openMenus() {
      let subscriptionId = null;
      if (
        this.merchant &&
        this.merchant.webSetting &&
        this.merchant.webSetting.subscription_id
      ) {
        subscriptionId = this.merchant.webSetting.subscription_id;
      } else if (this.merchant && this.merchant.merchantId) {
        subscriptionId = this.merchant.merchantId;
      }
      if (!subscriptionId) {
        return;
      }
      const url = "/menus/" + subscriptionId;
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
.restaurant-orders-page {
  width: 100%;
  min-height: 100vh;
  background-color: #f7f7f7;
}

.restaurant-orders-hero {
  position: relative;
  width: 100%;
  height: 260px;
  background-size: cover;
  background-position: center;
}

.restaurant-orders-hero-plain {
  background-color: #222;
}

.restaurant-orders-hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
}

.restaurant-orders-hero-inner {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.restaurant-orders-title {
  color: #ffffff;
  font-size: 28px;
  font-weight: 500;
  letter-spacing: 0.18em;
  text-align: center;
  padding: 0 16px;
}

.restaurant-orders-menu-btn {
  margin-top: 16px;
  padding: 10px 24px;
  border-radius: 20px;
  border: 1px solid #ffffff;
  background-color: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  font-size: 14px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.restaurant-orders-menu-btn:hover {
  background-color: #ffffff;
  color: #000000;
}

.restaurant-orders-content {
  max-width: 960px;
  margin: 24px auto 40px auto;
  padding: 0 16px 40px 16px;
}

.restaurant-orders-instruction {
  text-align: center;
  font-size: 16px;
  margin-bottom: 16px;
  color: #444;
}

.restaurant-orders-floor {
  margin-bottom: 24px;
}

.restaurant-orders-floor-title {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 12px;
}

.restaurant-orders-tables {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.restaurant-orders-table-btn {
  border-radius: 20px;
  border: 1px solid #ddd;
  padding: 8px 16px;
  background-color: #ffffff;
  cursor: pointer;
  font-size: 14px;
  min-width: 80px;
  text-align: center;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.restaurant-orders-table-btn:hover {
  background-color: #f0f0f0;
  border-color: #ccc;
}

.restaurant-orders-empty {
  text-align: center;
  color: #777;
  margin-top: 32px;
}

.restaurant-orders-confirm-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.restaurant-orders-confirm-dialog {
  background: #ffffff;
  border-radius: 8px;
  max-width: 400px;
  width: 90%;
  padding: 20px 20px 16px 20px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  animation: restaurant-orders-slide-up 0.25s ease-out;
}

.restaurant-orders-confirm-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
}

.restaurant-orders-confirm-body {
  font-size: 15px;
  margin-bottom: 20px;
}

.restaurant-orders-confirm-table {
  font-weight: 600;
  font-size: 24px;
  display: inline-block;
  margin-left: 4px;
}

.restaurant-orders-confirm-actions {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.restaurant-orders-btn {
  border-radius: 4px;
  padding: 8px 16px;
  border: 1px solid #ccc;
  cursor: pointer;
  font-size: 14px;
  background-color: #ffffff;
  flex: 1;
  text-align: center;
}

.restaurant-orders-btn.primary {
  background-color: #000000;
  color: #ffffff;
  border-color: #000000;
}

.restaurant-orders-btn.secondary:hover {
  background-color: #f0f0f0;
}

@keyframes restaurant-orders-slide-up {
  0% {
    transform: translateY(40px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RestaurantOrders.vue